import { useState } from "react"
import { getAutopilot } from "../api/api"

export default function Autopilot() {
  const [domain, setDomain] = useState("")
  const [data, setData] = useState(null)

  async function run() {
    const res = await getAutopilot(domain)
    setData(res.data)
  }

  return (
    <div className="page">
      <h1>SEO Autopilot</h1>
      <div className="card form-row">
        <label>
          Domain
          <input value={domain} onChange={(e) => setDomain(e.target.value)} placeholder="example.com" />
        </label>
        <button onClick={run}>Load fixes</button>
      </div>
      {data && <pre>{JSON.stringify(data, null, 2)}</pre>}
    </div>
  )
}
